import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'shared-components/Button/Button';
import AdminOptionMenu from 'shared-components/AdminOptionMenu/AdminOptionMenu';

const AdminOptionsButton = ({
  buttonType,
  options,
  selectedOption,
  disabled,
  buttonClass,
  menuStyle,
  children,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleClickButton = () => setIsMenuOpen((prevState) => !prevState);

  return (
    <div style={{ position: 'relative' }}>
      <Button
        buttonType={buttonType}
        disabled={disabled}
        className={buttonClass}
        onClick={handleClickButton}
      >
        {children}
      </Button>
      {isMenuOpen && (
        <AdminOptionMenu
          items={options}
          selectedItem={selectedOption}
          style={menuStyle}
          closeMenu={() => setIsMenuOpen(false)}
        />
      )}
    </div>
  );
};

AdminOptionsButton.propTypes = {
  buttonType: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
      onClick: PropTypes.func,
    })
  ).isRequired,
  selectedOption: PropTypes.string,
  disabled: PropTypes.bool,
  buttonClass: PropTypes.string,
  menuStyle: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
};

AdminOptionsButton.defaultProps = {
  selectedOption: null,
  disabled: false,
  buttonClass: null,
  menuStyle: null,
};

export default AdminOptionsButton;
